import './GlobalFontSizeVariables.css';
export var fontSizeWrapper = '_1cprvf30-2-0-1';